import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";

export default function RegionBlocked() {
  return (
    <PublicLayout>
      <div className="pt-40 pb-32 text-center px-6" data-testid="region-blocked">
        <p className="font-serif text-3xl italic text-[#5C6670]">
          No entries just yet.
        </p>
        <p className="mt-4 text-sm text-[#5C6670] max-w-md mx-auto">
          The journal is undergoing a little maintenance — new letters and essays will appear here soon.
        </p>
        <Link to="/" className="mt-6 inline-block gv-link text-sm tracking-[0.2em] uppercase text-[#C5A059]">
          Back to the home page
        </Link>
      </div>
    </PublicLayout>
  );
}
